import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ApplicationStatus } from 'types/application';
import { appStatusType } from 'utils/enums';
import { automationQueries } from 'queryKeys/automations';
import applicationStatusesAPI from 'api/applicationStatusesAPI';

export const useQueryGetApplicationStatusListData = (
  districtId: number,
  statusTypes: number[] = [appStatusType.archived],
  options?: Omit<UseQueryOptions<ApplicationStatus[], AxiosError>, 'queryKey' | 'queryFn'>
): UseQueryResult<ApplicationStatus[], AxiosError> => {
  return useQuery({
    queryKey: automationQueries.automations.statuses(districtId, statusTypes).queryKey,
    queryFn: () => {
      return applicationStatusesAPI.getAll({
        districtId,
        statusTypes,
      });
    },
    enabled: districtId !== undefined && districtId !== null,
    networkMode: 'always',
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};
